/** Subdominios que no identifican a un cliente. */
const RESERVADOS = new Set(['www', 'app', 'api', 'mail', 'localhost']);

/**
 * El cliente llega directo a escanear y entrar por `cliente.qrinv.app`.
 * La dirección principal (sin subdominio de cliente) es la presentación.
 */
export function slugDeHost(hostname: string): string | null {
  const host = hostname.split(':')[0]?.toLowerCase() ?? '';
  if (!host || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;
  const partes = host.split('.').filter((p) => p.length > 0);
  if (partes.length < 2) return null;
  const sub = partes[0] ?? '';
  if (!sub || RESERVADOS.has(sub)) return null;
  if (partes[partes.length - 1] === 'localhost') return sub;
  if (partes.length < 3) return null;
  return sub;
}
